<mat-checkbox [(ngModel)]="selected">
  <div>

    {{details.fileName}}
  </div>
</mat-checkbox>
